
export default {
  props: {
    document: {
      type: Object,
      required: true,
    },
    uid: {
      type: String,
      required: true,
    },
  },
}
